import { render, staticRenderFns } from "./DomainReport.vue?vue&type=template&id=04c00996&scoped=true&"
import script from "./DomainReport.vue?vue&type=script&lang=js&"
export * from "./DomainReport.vue?vue&type=script&lang=js&"
import style0 from "./DomainReport.vue?vue&type=style&index=0&id=04c00996&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c00996",
  null
  
)

export default component.exports